import locales from "./locales";

export const consts = {
	weAreHiring: true,
};

export const maximizeSentenceLetters = (sentence: string, maxChars: number) => {
	if (sentence.length <= maxChars) {
		return sentence;
	}
	let tokens = sentence.split(" ");
	let newSentence = tokens[0];
	//TODO wip short calculation
	return newSentence;
};

export const boldify = (str: string) => {
	return str
		.split("**")
		.map((value, index) =>
			index % 2 === 0
				? value
				: "<span class='accent'>" + value + "</span>"
		)
		.join("");
};

export const socials = [
	{
		name: "facebook",
		href: "https://www.facebook.com/mabiloft/",
		src: require("./images/facebook.svg"),
	},
	{
		name: "instagram",
		href: "https://www.instagram.com/mabiloft/",
		src: require("./images/instagram.svg"),
	},
	{
		name: "dribbble",
		href: "https://dribbble.com/Mabiloft",
		src: require("./images/dribbble.svg"),
	},
	{
		name: "linkedin",
		href: "https://www.linkedin.com/company/mabiloft/",
		src: require("./images/linkedin.svg"),
	},
	{
		name: "behance",
		href: "https://www.behance.net/Mabiloft",
		src: require("./images/behance.svg"),
	},
	{
		name: "medium",
		href: "https://medium.com/mabiloft",
		src: require("./images/medium.svg"),
	},
];

export const hexToRGBA = (hex: any, alpha: number) => {
	let c: any;

	// Check if hex string is a valid color
	if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
		// Remove # from the hex string and split in a array
		c = hex.substring(1).split("");

		// Eventually convert hex shortcut to full (e.g. #fff to #ffffff)
		if (c.length === 3) {
			c = [c[0], c[0], c[1], c[1], c[2], c[2]];
		}

		c = `0x${c.join("")}`;
		return `rgba(${(c >> 16) & 255}, ${(c >> 8) & 255}, ${c &
			255}, ${alpha})`;
	}
	throw new Error("Invalid HEX on RGBA conversion");
};

export const noSlashPath = (path: string) => {
	let clean = path.substring(path.startsWith("/") ? 1 : 0);
	if (clean.endsWith("/")) clean = clean.substring(0, clean.length - 1);
	return clean;
};

export const localizePath = (path: string, locale: string) => {
	let cleanPath = noSlashPath(path);
	// do not add locale path segment on default language
	if (locales[locale]["default"] === true) {
		return cleanPath;
	}

	const cleanLocale = noSlashPath(locale);

	// remove locale from path
	// if (cleanPath == cleanLocale || cleanPath.startsWith(cleanLocale + "/")) {
	//   cleanPath = noSlashPath(cleanPath.substr(cleanLocale.length));
	// }

	return cleanLocale + "/" + cleanPath;
};

export const isSafari =
	typeof navigator !== "undefined" &&
	/Version\/[\d\.]+.*Safari/.test(navigator.userAgent);
